import React from "react";
import PropTypes from "prop-types";
import FitRecommendation from "components/source/membership/fit/fit-recommendation";
import SKUSelector from "components/source/reservations/sku-selector";
import PDPSubmitActionsWrapper from "components/source/reservations/pdp-submit-actions-wrapper";
import { withRecommendations } from "components/source/shared/with-recommendations";
import { isBulk, isClearance, isRental } from "helpers/price-helper";
import { browserPropType } from "components/propTypes";
import UrgencySignalWrapper from "../products/urgency-signal/wrapper";

export class SaleableFormFieldsComponent extends React.Component {
  static propTypes = {
    browser: browserPropType,
    errors: PropTypes.object,
    isOneSize: PropTypes.bool.isRequired,
    isRentable: PropTypes.bool,
    onChange: PropTypes.func,
    product: PropTypes.object.isRequired,
    recommendations: PropTypes.arrayOf(PropTypes.shape),
    remaining: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    reservation: PropTypes.object,
    selectedSku: PropTypes.shape({
      size: PropTypes.string,
    }),
  };

  render() {
    const { errors, onChange, isOneSize, recommendations, reservation, product } = this.props;

    let sizeNames;
    if (isClearance(this.props.product.price)) {
      sizeNames = this.props.product.sizeScale.sizeName;
    }

    return (
      <div>
        <SKUSelector
          isRental={isRental(product.price)}
          isBulk={isBulk(product.price)}
          isClearance={isClearance(product.price)}
          error={errors?.reservation?.primarySku}
          id="product-primary-size"
          name="reservation[primarySku][id]"
          sizeNames={sizeNames}
          skus={product.skus}
          value={reservation?.primarySku?.id}
          onAnimatedInputChange={onChange}
        />
        {!isOneSize && (
          <UrgencySignalWrapper className="float-right mr-10 -mt-8" selectedSize={reservation?.primarySku?.id} />
        )}
        <FitRecommendation product={product} recommendations={recommendations} />
        <div className="add-to-bag-radio-container">
          <PDPSubmitActionsWrapper
            browser={this.props.browser}
            isBulk={isBulk(product.price)}
            isClearance={isClearance(product.price)}
            isExistingHold={Boolean(reservation?.primaryHoldId)}
            isOneSize={isOneSize}
            isRentable={product.isRentable}
            price={product.price}
            productId={product?.id}
            remaining={this.props.remaining}
            selectedSku={this.props.selectedSku}
          />
          <div className="flex justify-between">
            <p className="flex items-baseline flex-wrap p-0">All purchases are final.</p>
            {isOneSize && <UrgencySignalWrapper selectedSize={reservation?.primarySku?.id} />}
          </div>
        </div>
      </div>
    );
  }
}

export default withRecommendations()(SaleableFormFieldsComponent);
